import ajax from '../utils/ajax'

export default {
    list: () => ajax.get('/api/tags/'),
};